<template>
  <div class="">
    <div class="flex text-color-star">
      <BaseIcon
        v-for="index in allStar"
        :key="index"
        :size="size"
        :color="color"
        :name="name(index)"
        :class="{'rating-star--interactive': isInteractive}"
        @mouseover="hover(index)"
        @mouseleave="starInternal = 0"
        @click="$emit('rated', index)"
      />
    </div>
    <div
      v-if="message"
      :class="messageTypeText"
      class="rating-star__message"
    >
      <span class="flex items-center space-x-2">
        <BaseIcon name="info" size="xs" :color="messageType" />
        <span>{{ message }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseRatingStar',
  model: {
    prop: 'value',
    event: 'update'
  },
  props: {
    maxStar: {
      type: Number,
      default: 5
    },
    star: {
      type: Number,
      default: 1
    },
    size: {
      type: String,
      default: 'xs'
    },
    xSize: {
      type: String,
      default: 'xs'
    },
    isInteractive: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    messageType: {
      type: String,
      default: 'error',
      valid: ['warning', 'error']
    },
    color: {
      type: String,
      default: 'star'
    }
  },
  data () {
    return {
      starInternal: 0
    }
  },
  computed: {
    offStar () {
      return Number(this.maxStar) - Number(this.star)
    },
    onStar () {
      return Number(this.star) >= Number(this.maxStar) ? Number(this.star) : Number(this.star)
    },
    allStar () {
      return this.maxStar
    },
    messageTypeText () {
      return this.messageType === 'warning' ? 'text-warning' : 'text-error'
    }
  },
  methods: {
    name (index) {
      if (this.star % 1 && index === (Math.floor(this.star) + 1)) {
        return 'star_half'
      }
      return index <= (this.starInternal ? this.starInternal : this.star) ? 'star' : 'star_border'
    },
    hover (index) {
      if (!this.isInteractive) { return }
      this.starInternal = index
    }
  }
}
</script>

<style lang="scss" scoped>
.rating-star{
  &--interactive{
    @apply cursor-pointer;
  }
  &__message {
    @apply absolute mt-1 text__caption-xs--regular;
  }
}
</style>
